import { Component, OnInit, Injector } from '@angular/core';
import { MerchantsComponent } from './../merchants/merchants.component';
import { Transaction } from '../../data/Transaction';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-merchant-visahistory',
  templateUrl: './merchant-visahistory.component.html',
  styleUrls: ['./merchant-visahistory.component.css']
})
export class MerchantVisahistoryComponent extends MerchantsComponent
  implements OnInit {
  visaBalance = '';
  loading = false;
  showAllTrans = false;
  dateOptions: object;
  pagedResults: Transaction[];
  transactions: Transaction[] = [];
  selectedPage = 1;
  itemsPerPage = 10;
  stripAccount: any = { account: '0' };
  customerAccounts: any[] = [];
  transactionDateRange = 35; // This should reflex what is in TransactionController.java
  startDate: NgbDate;
  endDate: NgbDate;

  constructor(injector: Injector) {
    super(injector);
  }

  static format(date: NgbDate) {
    return (
      ('0' + date.month).slice(-2) +
      '/' +
      ('0' + date.day).slice(-2) +
      '/' +
      date.year
    );
  }

  ngOnInit() {
    this.endDate = this.calendar.getToday();
    const startDateWork = new Date();
    startDateWork.setDate(startDateWork.getDate() - this.transactionDateRange);
    this.startDate = new NgbDate(
      startDateWork.getFullYear(),
      startDateWork.getMonth() + 1,
      startDateWork.getDate()
    );
    this.loading = true;
    const merchant = this.merchantService.getSelectedMerchant();
    this.getMerchantAccount(merchant).subscribe(merchDetails => {
      this.customerAccounts = merchDetails.customerAccounts;
      this.stripAccount = merchDetails.customerAccounts[0];
      this.loading = false;
    });
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  pageSet(page) {
    this.selectedPage = page;
    this.setPagedResults();
  }

  setPagedResults() {
    if (this.transactions.length <= 10) {
      this.pagedResults = this.transactions;
    } else {
      this.pagedResults = this.transactions.slice(
        (this.selectedPage - 1) * this.itemsPerPage,
        (this.selectedPage - 1) * this.itemsPerPage + this.itemsPerPage
      );
    }
  }

  reverse(transaction: any) {
    this.loading = true;
    const that = this;
    this.cardHolderService.reverse(transaction.tranSequence).subscribe(
      () => {
        transaction.reverseState = -1;
        this.messageService.success('Reversal Successful');
        this.refreshMerchantTransactionData();
        this.loading = false;
      },
      error => {
        this.loading = false;
        that.messageService.error(error.error);
      }
    );
  }

  getSelectedTransHistory(eve) {
    this.transactions = [];
    const arr = [];
    const account = eve.target.value;
    if (account === '') {
      this.transactions = this.transactions;
    } else {
      this.transactions.forEach(function(trans) {
        if (trans.account === +account) {
          arr.push(trans);
        }
      });
      this.transactions = arr;
    }
  }

  refreshMerchantTransactionData() {
    const startDateString = MerchantVisahistoryComponent.format(this.startDate);
    const endDateString = MerchantVisahistoryComponent.format(this.endDate);
    this.loading = true;
    this.transactions = [];
    const chipAccount = this.merchantAccountInfo.customerAccounts.slice(
      1,
      this.merchantAccountInfo.customerAccounts.length
    );
    this.merchantService
      .getMerchantTransactions(
        this.stripAccount.account,
        chipAccount[0].account,
        startDateString,
        endDateString
      )
      .subscribe(
        results => {
          results.transactions.sort((objA, objB) => 
            new Date(objB.postDate).getTime() - new Date(objA.postDate).getTime()
          );
          this.transactions = results.transactions;
          this.transactions = this.transactions;
        },
        error => {
          console.log(error);
        },
        () => {
          this.loading = false;
        }
      );
  }
}
